import { SiteAmenityModel } from './SiteAmenityModel';
import { SiteWeatherForecastModel } from './SiteWeatherForecastModel';
import { SiteAlertModel } from './SiteAlertModel';
import { NearbySiteModel } from './NearbySiteModel';
import { SiteMonitoringDetails } from './SiteMonitoringDetails';


export enum TrendTypes  
{
    AnnualGrade = "Annual Grade",
    Enterococci ="Enterococci",
    Rainfall = "Rainfall to 9am",
    WaterTemp ="Water Temp"
}


export type SiteTrends = { Name : TrendTypes };

export class SiteDetailsModel {

    // public Identifier: string;
    // public SiteName: string;
    // public PollutionForecast: string;
    // public LatestResultStarRating: number | null;
    // public SiteType: string | null;
    // public SiteCategory: string | null;
    // public Council: string | null;
    // public Region: string | null;
    // public PartnerGroup: string | null;
    // public Description: string | null;
    // public SitePhoto: string | null;
    // public WebLink: string | null;
    // public PatrolDescription: string | null;
    // public LatestResultDt: Date | null;
    // public LatestResultDescription: string | null;
    // public PollForecastDt: Date | null;
    // public PollutionDescription: string | null;
    // public WaterTemp: number | null;
    // public AnnualGrade: string | null;
    // public Amenities: SiteAmenityModel[];
    // public WeatherForecast: SiteWeatherForecastModel[];
    // public Alerts: SiteAlertModel[];
    // public NearbySites : NearbySiteModel[];
    // public MonitoringDetails: SiteMonitoringDetails[];
    // public Trends : SiteTrends[];
    // public RainGaugeName : string | null;
    // public ShowSwell : boolean | null;
    // public ShowTide : boolean | null;
    // public ShowWaterTemp : boolean | null;


   
    public Identifier: any;
    public SiteName: any;
    public PollutionForecast: any;
    public LatestResultStarRating: any | null;
    public SiteType: any;
    public SiteCategory: any;
    public Council: any;
    public Region: any;
    public PartnerGroup: any;
    public Description: any;
    public SitePhoto: any;
    public WebLink: any;
    public PatrolDescription: any;
    public LatestResultDt: any;
    public LatestResultDescription: any;
    public PollForecastDt: any;
    public PollutionDescription: any;
    public WaterTemp: any;
    public AnnualGrade: any;
    public Amenities: any[];
    public WeatherForecast: any[];
    public Alerts: any[];
    public NearbySites : any[];
    public MonitoringDetails: any[];
    public Trends : any[];
    public RainGaugeName : any;
    public ShowSwell : any;
    public ShowTide : any;
    public ShowWaterTemp : any;
    public ShowSubscription : any;
    
    constructor(
        
    ) {}
   
}
